// src/components/textarea/textarea.styles.ts
import { tv } from "tailwind-variants";
var textareaStyles = tv({
  slots: {
    container: "flex flex-col gap-2",
    label: "text-neutral-900 font-semibold text-base",
    inputWrapper: "flex justify-center items-center bg-neutral-0 border border-neutral-200 hover:border-neutral-500 rounded cursor-text has-[:focus]:border-secondary transition overflow-hidden px-4",
    textarea: "outline-none w-full pt-5 pb-3 min-h-[150px]",
    error: "text-primary-700 text-xs",
    helperText: "flex text-sm text-neutral-600",
    lengthContainer: "flex justify-between",
    minMaxText: "text-xs leading-5 text-neutral-600"
  },
  variants: {
    isInvalid: {
      true: {
        inputWrapper: "!border-primary-700"
      }
    }
  }
});
export {
  textareaStyles
};
